<div class="p-6 space-y-4">
  @if (error) {
    <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">
      {{ error }}
    </div>
  }

  <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Nombre <span class="text-error-500">*</span>
      </label>
      <input type="text" formControlName="name" maxlength="150"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('name')"
        [class.border-gray-300]="!hasError('name')" />
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
      <textarea formControlName="description" rows="2"
        class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Categoría padre</label>
      <select formControlName="idParent"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500">
        <option [ngValue]="null">— Raíz —</option>
        @for (p of parentOptions; track p.id) {
          @if (p.id !== itemId) {
            <option [ngValue]="p.id">{{ p.name }}</option>
          }
        }
      </select>
    </div>

    <div class="grid grid-cols-2 gap-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Orden</label>
        <input type="number" formControlName="sortOrder"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Color</label>
        <div class="flex items-center gap-2">
          <input type="color" formControlName="color"
            class="h-10 w-12 cursor-pointer rounded border border-gray-300 dark:border-gray-600" />
          <input type="text" formControlName="color"
            class="flex-1 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white font-mono" />
        </div>
      </div>
    </div>

    <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
      <input type="checkbox" formControlName="isActive" class="rounded border-gray-300 dark:border-gray-600" />
      Activa
    </label>

    <div class="flex justify-end gap-2 pt-3 border-t border-gray-200 dark:border-gray-700">
      <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
      <app-button type="button" [disabled]="saving" (btnClick)="guardar()">
        @if (saving) { Guardando… } @else { {{ isEditing ? 'Actualizar' : 'Guardar' }} }
      </app-button>
    </div>
  </form>
</div>
